export default __webpack_public_path__ + "static/simple-column-ec2b622da2ecc7c2c14970f706edf34f.png";